export default __webpack_public_path__ + "static/media/userIcon2.6123f23b.svg";